import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import userSystemRepository from '../../repositories/setting/userSystemRepository';

const dataUserSystem = {
  name: null,
  phone: null,
  email: null,
  username: null,
};

export const useUserSystemStore = defineStore('userSystemStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataUserSystem),
    hasFormError: structuredClone(dataUserSystem),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataUserSystem = await userSystemRepository.getData(params);
        if (dataUserSystem.data.status === 200) {
          this.listData = dataUserSystem.data.data.user_system.list;
          this.pagination = dataUserSystem.data.data.user_system.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveUserSystem = await userSystemRepository.saveData(params);
        if (saveUserSystem.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        user_id: id,
      };
      const dataDetailUserSystem = await userSystemRepository.getDataDetail(params);

      if (dataDetailUserSystem.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailUserSystem.data.data;
        this.formData = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          username: data.username,
        };
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          user_id: id,
          ...this.formData,
        };
        const updateUserSystem = await userSystemRepository.updateData(params);
        if (updateUserSystem.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          user_id: id,
        };
        const deleteUserSystem = await userSystemRepository.deleteData(params);
        if (deleteUserSystem.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataUserSystem);
      }
      this.hasFormError = structuredClone(dataUserSystem);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
    async getUserLogin() {
      this.isSuccess = false;

      const dataDetailUserSystem = await userSystemRepository.getUserLogin();

      if (dataDetailUserSystem.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailUserSystem.data.data;
        this.formData = {
          name: data.name,
          phone: data.phone,
          email: data.email,
          username: data.username,
        };
      }
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useUserSystemStore, import.meta.webpackHot));
}
